import { render, staticRenderFns } from "./ComissoesServicosConsolidado.vue?vue&type=template&id=671b71d7&scoped=true&"
import script from "./ComissoesServicosConsolidado.vue?vue&type=script&lang=js&"
export * from "./ComissoesServicosConsolidado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671b71d7",
  null
  
)

export default component.exports